/* Omelva - popup de captacion.
   Nunca se abre encima del banner de cookies de Shopify: espera a que la
   visitante lo resuelva. Si no lo resuelve, el popup no aparece.
   Tampoco se abre si ya ha tocado un enlace: si no, el popup sale justo
   cuando pulsa "Descubrir ahora" y se queda el toque. */
(function () {
  var pop = document.querySelector('.ow-lead');
  if (!pop) return;

  var clave = 'owLead-' + (pop.id || 'omelva');
  var frecuencia = pop.dataset.frecuencia;
  var retraso = parseFloat(pop.dataset.retraso);
  if (!isFinite(retraso) || retraso < 0) retraso = 3000;

  var exito = !!pop.querySelector('[data-ow-lead-exito]');
  var error = !!pop.querySelector('[data-ow-lead-error]');
  var temporizador = null;
  var abriendo = false;
  var sospechas = 0;
  var navegando = false;

  function almacen() { return frecuencia === 'sesion' ? window.sessionStorage : window.localStorage; }

  function yaVisto() {
    if (frecuencia === 'siempre') return false;
    try {
      var marca = almacen().getItem(clave);
      if (!marca) return false;
      if (frecuencia === 'dia') return Date.now() - parseInt(marca, 10) < 86400000;
      if (frecuencia === 'semana') return Date.now() - parseInt(marca, 10) < 604800000;
      return true;
    } catch (e) { return false; }
  }

  function marcar() { try { almacen().setItem(clave, String(Date.now())); } catch (e) {} }

  function marcarSuscrita() {
    try {
      window.localStorage.setItem(clave, String(Date.now()));
      window.localStorage.setItem(clave + '-ok', '1');
      window.sessionStorage.setItem(clave, String(Date.now()));
    } catch (e) {}
  }

  function suscritaYa() {
    try { return window.localStorage.getItem(clave + '-ok') === '1'; } catch (e) { return false; }
  }

  /* El banner de consentimiento de Shopify va a z-index 2000000: si esta
     visible, taparia el popup. OJO: es position:fixed, asi que offsetParent
     siempre es null y no sirve para saber si se ve. Medimos su altura. */
  function bannerCookies() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var cs = window.getComputedStyle(b);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return b.getBoundingClientRect().height > 0;
  }

  function cuandoNoHayaBanner(hacer) {
    if (!bannerCookies()) { hacer(); return; }
    var vigilante = setInterval(function () {
      if (bannerCookies()) return;
      clearInterval(vigilante);
      setTimeout(hacer, 1200);
    }, 400);
  }

  /* Toque en un enlace de la tienda (fuera del popup) = se va a otra pagina.
     Se marca en fase de captura y en pointerdown, antes de que llegue el
     click, para ganarle al temporizador del popup. */
  function vigilarEnlaces(evento) {
    var enlace = evento.target && evento.target.closest ? evento.target.closest('a[href]') : null;
    if (enlace && !pop.contains(enlace)) navegando = true;
  }
  document.addEventListener('pointerdown', vigilarEnlaces, true);
  document.addEventListener('click', vigilarEnlaces, true);
  window.addEventListener('pageshow', function (evento) { if (evento.persisted) navegando = false; });

  function abrir(enfocar) {
    abriendo = true;
    pop.hidden = false;
    document.body.style.overflow = 'hidden';
    void pop.offsetWidth;
    pop.classList.add('is-open');
    abriendo = false;
    if (enfocar) {
      var campo = pop.querySelector('.ow-lead__input');
      if (campo) campo.focus({ preventScroll: true });
    }
  }

  function cerrar() {
    pop.classList.remove('is-open');
    document.body.style.overflow = '';
    marcar();
    if (temporizador) clearTimeout(temporizador);
    temporizador = setTimeout(function () { pop.hidden = true; }, 350);
  }

  pop.querySelectorAll('[data-cerrar]').forEach(function (boton) { boton.addEventListener('click', cerrar); });
  document.addEventListener('keydown', function (evento) { if (evento.key === 'Escape' && !pop.hidden) cerrar(); });

  var copiar = pop.querySelector('[data-ow-lead-copiar]');
  if (copiar) {
    copiar.addEventListener('click', function () {
      var codigo = pop.querySelector('[data-ow-lead-codigo]');
      if (!codigo) return;
      var texto = codigo.textContent.trim();
      var hecho = function () {
        copiar.textContent = 'Copiado';
        setTimeout(function () { copiar.textContent = 'Copiar'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(texto).then(hecho, function () {}); }
    });
  }

  setInterval(function () {
    if (abriendo || pop.classList.contains('is-open') || pop.hidden) { sospechas = 0; return; }
    sospechas += 1;
    if (sospechas < 2) return;
    pop.hidden = true;
    document.body.style.overflow = '';
    sospechas = 0;
  }, 1000);

  if (window.Shopify && window.Shopify.designMode) { abrir(false); return; }
  if (exito) { marcarSuscrita(); abrir(false); return; }
  if (error) { abrir(true); return; }
  if (suscritaYa() || yaVisto()) return;
  setTimeout(function () { cuandoNoHayaBanner(function () { if (!navegando) abrir(false); }); }, retraso);
})();